import PropTypes from "prop-types";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);
const showConfirmationAlert = ({
  title,
  text,
  confirmButtonText = "Yes!",
  cancelButtonText = "Cancel",
}) => {
  return MySwal.fire({
    title: title,
    text: text,
    showCancelButton: true,
    confirmButtonColor: "#00ff00",
    confirmButtonText: confirmButtonText,
    cancelButtonColor: "#ff0000",
    cancelButtonText: cancelButtonText,
  });
};

showConfirmationAlert.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  confirmButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
};
export default showConfirmationAlert;
